import React from "react";

const ProjectsPage = () => {
  return (
    <div style={{ padding: "100px", textAlign: "center" }}>
      <h1>Projects Coming Soon</h1>
    </div>
  );
};

export default ProjectsPage;